var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    fill: "none",
    height: "100%",
    viewBox: "0 0 164 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wallet-connect-logo"
  }, "Wallet Connect Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "wallet-connect-logo"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4018 19.5383C60.0094 -6.51275 103.149 -6.51275 129.756 19.5383L132.959 22.6735C134.289 23.9761 134.289 26.0879 132.959 27.3905L122.004 38.1157C121.339 38.7669 120.261 38.7669 119.595 38.1157L115.189 33.8011C96.6266 15.6273 66.5315 15.6273 47.9694 33.8011L43.2502 38.4216C42.585 39.0729 41.5065 39.0729 40.8413 38.4216L29.887 27.6965C28.5567 26.3939 28.5567 24.2821 29.887 22.9795L33.4018 19.5383ZM152.411 41.719L162.16 51.2645C163.49 52.567 163.49 54.6789 162.16 55.9814L118.2 99.0231C116.869 100.326 114.712 100.326 113.382 99.0231C113.382 99.0231 113.382 99.0231 113.382 99.0231L82.1815 68.4752C81.8489 68.1495 81.3096 68.1495 80.977 68.4752C80.977 68.4752 80.977 68.4752 80.977 68.4752L49.7772 99.0231C48.4469 100.326 46.2899 100.326 44.9595 99.0231C44.9595 99.0231 44.9595 99.0231 44.9595 99.0231L0.997783 55.9809C-0.332594 54.6783 -0.332594 52.5665 0.997783 51.2639L10.7471 41.7185C12.0775 40.4159 14.2345 40.4159 15.5649 41.7185L46.7658 72.2668C47.0984 72.5925 47.6376 72.5925 47.9702 72.2668C47.9702 72.2668 47.9702 72.2668 47.9702 72.2668L79.1696 41.7185C80.4999 40.4159 82.6569 40.4159 83.9873 41.7184C83.9873 41.7184 83.9873 41.7184 83.9874 41.7184L115.188 72.2668C115.521 72.5924 116.06 72.5924 116.393 72.2668L147.593 41.719C148.923 40.4165 151.08 40.4165 152.411 41.719Z",
    fill: "#3B99FC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.a6d7a6da6401771d3c61d88b42dd51de.svg";
export { ForwardRef as ReactComponent };